import { createStore, combineReducers , applyMiddleware} from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
import ProfileReducer from './AuthSlice';
import VisitorReducer from './apps/widgets/VisitorSlice';
import TokenReducer from './apps/widgets/TokenSlice';

import AuthReducer from './AuthSlice'
import ErrorReducer from './ErrorSlice'
import TenantReducer from './apps/tenants/TenantSlice'
import RegistrationReducer from './apps/registrations/RegistrationSlice'
import TenantSetupSlice from './apps/registrations/TenantSetupSlice'

import EventSlice from './apps/events/EventSlice'
import NotificationSlice from './apps/emails/NotificationSlice'
import ActivityLogReducer from './apps/activitylog/ActivityLogSlice'
import { setError } from './ErrorSlice'

const rootReducer = combineReducers({
    customizer: CustomizerReducer,
    profileReducer : ProfileReducer,
    visitorReducer : VisitorReducer,
    tokenReducer : TokenReducer,
    authReducer: AuthReducer,
    tenant_reducer: TenantReducer,
    activityLogReducer:ActivityLogReducer,
    registration_reducer : RegistrationReducer,
    event_reducer : EventSlice,
    notification_reducer : NotificationSlice,
    tenant_setup_reducer : TenantSetupSlice
});

const thunk = ({ dispatch, getState }) => next => action => {
  if (typeof action === 'function') {
    console.log('function types')
    return action(dispatch, getState).catch((error)=> {
      console.log('report your error')
      console.log(error)
      dispatch(setError(error))
    })
  }
  return next(action);
};


export const store = createStore(
  rootReducer, 
  applyMiddleware(thunk)
);
